"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
const ferrum_plumbing_1 = require("ferrum-plumbing");
const STAGING_PREFIXES = ['https://staging'];
class Environment {
    static uiStage() {
        var _a;
        if (!!process.env.OVERRIDE_UI_STAGE) {
            return process.env.OVERRIDE_UI_STAGE;
        }
        // @ts-ignore
        const base = (((_a = window.location) === null || _a === void 0 ? void 0 : _a.origin) || '').toLowerCase();
        const isCompiled = process.env.NODE_ENV === 'production';
        if (!isCompiled) {
            return 'dev';
        }
        if (STAGING_PREFIXES.find(p => base.startsWith(p))) {
            return 'staging';
        }
        return 'prod';
    }
    static defaultEndPoint() {
        const ep = Environment.DEFAULT_ENDPOINTS[Environment.uiStage()];
        ferrum_plumbing_1.ValidationUtils.isTrue(!!ep, `No endpoint for "${Environment.uiStage()}"`);
        return ep;
    }
}
exports.Environment = Environment;
Environment.DEFAULT_ENDPOINTS = {
    dev: 'http://localhost:8080',
    staging: 'https://an54zzyt9h.execute-api.ap-south-1.amazonaws.com/default/test',
    prod: 'https://sij6ulh6gc.execute-api.us-east-2.amazonaws.com/default/prod-gateway-backend',
};
//# sourceMappingURL=Environment.js.map